import { api } from './apiClient';

export interface Category {
  id: number;
  name: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

interface CategoriesResponse {
  categories: Category[];
  count: number;
}

interface CategoryResponse {
  category: Category;
}

export const categoryService = {
  /**
   * Get all categories
   */
  getCategories: async (includeInactive = false): Promise<CategoriesResponse> => {
    return api.get<CategoriesResponse>('/categories', {
      params: includeInactive ? { includeInactive: 'true' } : undefined
    });
  },

  /**
   * Get category by ID
   */
  getCategory: async (id: number): Promise<CategoryResponse> => {
    return api.get<CategoryResponse>(`/categories/${id}`);
  },

  /**
   * Create new category
   */
  createCategory: async (name: string, description?: string): Promise<CategoryResponse> => {
    return api.post<CategoryResponse>('/categories', { name, description });
  },

  /**
   * Update category
   */
  updateCategory: async (id: number, data: { name: string; description?: string; isActive?: boolean }): Promise<CategoryResponse> => {
    return api.put<CategoryResponse>(`/categories/${id}`, data);
  },
};
